// @flow strict

/**
 * @fileoverview A module containing action type definitions related to Users
 */

import type { AuthRole } from '@rachio-npm/com-rachio-web-core/types/auth'
import type { DisplayUnit } from '@rachio-npm/com-rachio-web-core/types/core'
import type {
  PreferenceName,
  UserPreference
} from '@rachio-npm/com-rachio-web-core/types/user/userPreference'
import type { User } from '@rachio-npm/com-rachio-web-core/types/user'

export const USER_ADD_EVENT = 'RACHIO/USER/ADD_EVENT'
export const USER_CREATE_INIT = 'RACHIO/USER/CREATE_INIT'
export const USER_CREATE_COMPLETE = 'RACHIO/USER/CREATE_COMPLETE'
export const LOGIN_INIT = 'RACHIO/USER/LOGIN_INIT'
export const LOGIN_COMPLETE = 'RACHIO/USER/LOGIN_COMPLETE'
export const USER_REQUEST_INIT = 'RACHIO/USER/REQUEST_INIT'
export const USER_REQUEST_COMPLETE = 'RACHIO/USER/REQUEST_COMPLETE'
export const USER_UPDATE_INIT = 'RACHIO/USER/UPDATE_INIT'
export const UPDATE = 'RACHIO/USER/UPDATE'
export const USER_UPDATE_COMPLETE = 'RACHIO/USER/UPDATE_COMPLETE'
export const USER_INVALIDATE_DATA = 'RACHIO/USER/INVALIDATE_DATA'
export const LOGOUT = 'RACHIO/USER/LOGOUT'
export const GET_PREFERENCE_INIT = 'RACHIO/USER/GET_PREFERENCE_INIT'
export const SET_PREFERENCE = 'RACHIO/USER/SET_PREFERENCE'
export const GET_PREFERENCE_COMPLETE = 'RACHIO/USER/GET_PREFERENCE_COMPLETE'
export const GET_DEVICES_INIT = 'RACHIO/USER/GET_DEVICES_INIT'
export const SET_DEVICES_IDS = 'RACHIO/USER/SET_DEVICES_IDS'
export const GET_DEVICES_COMPLETE = 'RACHIO/USER/GET_DEVICES_COMPLETE'
export const GET_LOCATIONS_INIT = 'RACHIO/USER/GET_LOCATIONS_INIT'
export const GET_LOCATIONS_COMPLETE = 'RACHIO/USER/GET_LOCATIONS_COMPLETE'
export const ADD_LOCATION = 'RACHIO/USER/ADD_LOCATION'
export const REMOVE_LOCATION = 'RACHIO/USER/REMOVE_LOCATION'
export const UPDATE_PASSWORD_INIT = 'RACHIO/USER/UPDATE_PASSWORD_INIT'
export const UPDATE_PASSWORD_COMPLETE = 'RACHIO/USER/UPDATE_PASSWORD_COMPLETE'
export const GET_API_KEY_INIT = 'RACHIO/USER/GET_API_KEY_INIT'
export const GET_API_KEY_COMPLETE = 'RACHIO/USER/GET_API_KEY_COMPLETE'
export const MASK_AS_USER = 'RACHIO/USER/MASK_AS_USER'

/**
 * @typedef {Object} LoginRequestInitAction
 * @property {LOGIN_REQUEST_INIT} type
 */

/**
 * @typedef {Object} LoginRequestCompleteAction
 * @property {LOGIN_REQUEST_SUCCESS} type
 */

/**
 * @typedef {Object} UserRequestInitAction
 * @property {USER_REQUEST_INIT} type
 * @property {string} userId
 */

/**
 * @typedef {Object} UserRequestCompleteAction
 * @property {LOGIN_REQUEST_SUCCESS} type
 * @property {string} userId
 * @property {User} data
 */

// FLOWTYPES //////////////////////////////////////////////////////////////////

export type UserModel = { ...User, META: UserMETA }

export type UserMETA = {|
  lastPulled: number,
  requestStatus: string,
  locationIds: Array<string>
|}

export type Role = 'MANAGER' | 'QUICK_RUN' | 'OWNER'

export type SOM = DisplayUnit

export type UsageUnit = 'TIME' | 'ESTIMATED_VOLUME'

export type Preference = UserPreference

export type { AuthRole, User, PreferenceName }
